import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const ContactsBookIcon = createSvgIcon(
  <>
    <path
      d="M0.899994 17.0328V3.2047C0.899994 2.59346 1.14281 2.00726 1.57502 1.57505C2.00723 1.14284 2.59343 0.900024 3.20467 0.900024H15.6499V19.3375H3.20467C2.59343 19.3375 2.00723 19.0946 1.57502 18.6624C1.14281 18.2302 0.899994 17.644 0.899994 17.0328ZM0.899994 17.0328C0.899994 16.4215 1.14281 15.8353 1.57502 15.4031C2.00723 14.9709 2.59343 14.7281 3.20467 14.7281H15.6499M8.27497 8.275C9.29324 8.275 10.1187 7.44953 10.1187 6.43125C10.1187 5.41298 9.29324 4.58751 8.27497 4.58751C7.2567 4.58751 6.43122 5.41298 6.43122 6.43125C6.43122 7.44953 7.2567 8.275 8.27497 8.275ZM8.27497 8.275C9.00845 8.275 9.7119 8.56637 10.2306 9.08503C10.7492 9.60368 11.0406 10.3071 11.0406 11.0406M8.27497 8.275C7.54148 8.275 6.83804 8.56637 6.31938 9.08503C5.80073 9.60368 5.50935 10.3071 5.50935 11.0406"
      {...strokeProps}
    />
  </>,
  { displayName: 'ContactsBookIcon', viewBox: '0 0 17 21' }
);
